var _defs, _path, _path2, _path3, _g, _use, _path4, _path5, _use2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-ke",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ke-a",
    strokeMiterlimit: 10,
    d: "m-28.6 47.5 1.8 1 46.7-81c2.7-.6 4.2-3.2 5.7-5.8 1-1.8 5-8.7 6.7-17.7a58 58 0 0 0-11.9 14.7c-1.5 2.6-3 5.2-2.3 7.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M0 0h640v144H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#060",
    d: "M0 336h640v144H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ke-b",
    transform: "matrix(3 0 0 3 320 240)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ke-a",
    width: "100%",
    height: "100%",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ke-a",
    width: "100%",
    height: "100%",
    fill: "#fff"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ke-b",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 640 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    d: "M640.5 168H377c-9-24-39-72-57-72s-48 48-57 72H-.2v144H263c9 24 39 72 57 72s48-48 57-72h263.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "ke-c",
    d: "M377 312c9-24 15-48 15-72s-6-48-15-72c-9 24-15 48-15 72s6 48 15 72"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ke-c",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 640 0)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "matrix(3 0 0 3 320 240)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 4,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "ke-d",
    d: "M1 5.8s4 8 4 21-4 21-4 21z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ke-d",
    width: "100%",
    height: "100%",
    transform: "scale(-1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ke-d",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ke-d",
    width: "100%",
    height: "100%",
    transform: "scale(1 -1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKe);
export default __webpack_public_path__ + "static/media/ke.c33fd65f194add67ba64f085aacde118.svg";
export { ForwardRef as ReactComponent };